import { SectionShell, Field } from "./SectionShell";
import { Textarea } from "../ui/textarea";
import { Input } from "../ui/input";
import { inputCls } from "./constants";

export default function ContextTab({ data, update, onVoice }) {
  const setCtx = (key, value) => update({ context: { ...data.context, [key]: value } });
  return (
    <SectionShell eyebrow="Section 1 · 5 min" title="Context Setting" voiceSection="context" onVoice={onVoice}>
      <div className="space-y-6">
        <Field label="60-second version of your business — what do you do and who do you serve?">
          <Textarea data-testid="ctx-business" className={inputCls} rows={3} value={data.context?.business_summary || ""}
            onChange={(e) => setCtx("business_summary", e.target.value)} />
        </Field>
        <Field label="How many people are on your team, and who handles what?">
          <Textarea data-testid="ctx-team" className={inputCls} rows={3} value={data.context?.team_description || ""}
            onChange={(e) => setCtx("team_description", e.target.value)} />
        </Field>
        <Field label="What does a typical day look like — where does your time actually go?">
          <Textarea data-testid="ctx-day" className={inputCls} rows={3} value={data.context?.typical_day || ""}
            onChange={(e) => setCtx("typical_day", e.target.value)} />
        </Field>

        <div className="pt-6 border-t border-navy/10">
          <div className="eyebrow text-gold mb-2">Why Now</div>
          <p className="text-xs text-navy/60 mb-5">Context that drives the Intake Brief, Sprint Charter, and Follow-Up Email.</p>
          <div className="space-y-6">
            <Field label="What triggered you to reach out right now?">
              <Textarea data-testid="ctx-trigger" className={inputCls} rows={2} value={data.context?.trigger_event || ""}
                onChange={(e) => setCtx("trigger_event", e.target.value)}
                placeholder="A growth milestone, a hiring squeeze, a missed-lead crisis, a tool migration, an upcoming launch..." />
            </Field>
            <Field label="If nothing changes in 6 months, what does that cost you?">
              <Textarea data-testid="ctx-cost-inaction" className={inputCls} rows={2} value={data.context?.cost_of_inaction || ""}
                onChange={(e) => setCtx("cost_of_inaction", e.target.value)}
                placeholder="Lost revenue, burnout, churn, missed launch dates — quantify if possible." />
            </Field>
            <Field label="How do customers find you, and what's their journey to buying?">
              <Textarea data-testid="ctx-journey" className={inputCls} rows={2} value={data.context?.customer_journey || ""}
                onChange={(e) => setCtx("customer_journey", e.target.value)}
                placeholder="Top sources, average sales cycle, typical decision-makers." />
            </Field>
            <Field label="Who needs to sign off on bringing in outside help?">
              <Input data-testid="ctx-decision" className={inputCls} value={data.context?.decision_authority || ""}
                onChange={(e) => setCtx("decision_authority", e.target.value)}
                placeholder="e.g. Owner only / Owner + spouse / Partners / Board" />
            </Field>
          </div>
        </div>
      </div>
    </SectionShell>
  );
}
